import * as React from 'react'
import { FC } from 'react'
import { Field, useField } from 'formik'
import { IFilterProps, Ternary } from '../typings'
import CollapsibleFilter from './atoms/CollapsibleFilter'

import Grid from '@mui/material/Grid'
import MenuItem from '@mui/material/MenuItem'
import { MuiTextFieldFormik } from '@user/components/Formik'

interface Props extends IFilterProps {
  trueLabel: string
  falseLabel: string
  emptyLabel: string
}

export const TernaryFilter: FC<Props> = ({
  name,
  label,
  trueLabel,
  falseLabel,
  emptyLabel,
}) => {
  const path = `filters.${name}.value`

  const [{ value }] = useField<Ternary>(path)

  const subLabel = React.useMemo(
    () => (value === 'true' ? trueLabel : value === 'false' ? falseLabel : ''),
    [falseLabel, trueLabel, value],
  )

  return (
    <CollapsibleFilter
      label={label}
      subLabel={(expanded) => !expanded && subLabel}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Field
            name={path}
            component={MuiTextFieldFormik}
            select
            size="small"
            fullWidth
          >
            <MenuItem value="empty">{emptyLabel}</MenuItem>
            <MenuItem value="true">{trueLabel}</MenuItem>
            <MenuItem value="false">{falseLabel}</MenuItem>
          </Field>
        </Grid>
      </Grid>
    </CollapsibleFilter>
  )
}
TernaryFilter.displayName = 'TernaryFilter'
